module.exports = __webpack_public_path__ + "img/11.1a12b456.jpg";